// extracted by mini-css-extract-plugin
module.exports = {"login_gray_box":"sIOu5"};